export default __webpack_public_path__ + "static/media/mic_off.0c4db4f6.svg";